import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  info() {
    return api.get(`client/user-info`);
  },
  profilePicture(data) {
    return api.post(`client/user-profile`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
